module.exports = __webpack_public_path__ + "static/img/tooltip-ground-station-fov.a1587aa.png";